export default __webpack_public_path__ + "static/media/639.4e894f5e.jpg";